module.exports = __webpack_public_path__ + "static/pods-2f381b09a233aca32410731e96d4145a.png";